<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none">
    <div v-if="ticketData">
      <div class="xl:grid xl:grid-cols-3">
        <div class="xl:col-span-2 xl:pr-4">
          <div class="bg-white rounded p-4">
            <div>
              <div
                class="md:flex md:items-center md:justify-between md:space-x-4 xl:border-b xl:pb-6"
              >
                <div>
                  <h1 class="text-2xl font-bold text-gray-900">
                    {{ ticketData.title }}
                  </h1>
                  <p class="mt-2 text-sm text-gray-500">
                    <span class="font-medium text-gray-900">{{
                      ticketData.ticket_id
                    }}</span>
                    opened by
                    <span class="font-medium text-gray-900">{{
                      ticketData.owner.name
                    }}</span>
                    in
                    <span class="font-medium text-gray-900">{{
                      ticketData.category.name
                    }}</span>
                  </p>
                </div>
                <!-- <div class="mt-4 flex space-x-3 md:mt-0">
                  <button
                    type="button"
                    class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    <svg
                      class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                      x-description="Heroicon name: solid/pencil"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                      ></path>
                    </svg>
                    <span>Edit</span>
                  </button>
                  <button
                    type="button"
                    class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                  >
                    <svg
                      class="-ml-1 mr-2 h-5 w-5 text-gray-400"
                      x-description="Heroicon name: solid/bell"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"
                      ></path>
                    </svg>
                    <span>Subscribe</span>
                  </button>
                </div> -->
              </div>
              <aside class="mt-8 xl:hidden">
                <h2 class="sr-only">Details</h2>
                <div class="space-y-5">
                  <div
                    class="flex items-center space-x-2"
                    v-if="ticketData.status == 'Closed'"
                  >
                    <span
                      class="h-5 w-5 text-gray-500 flex items-center justify-center"
                    >
                      <i class="fa fa-lock"></i>
                    </span>
                    <span class="text-gray-700 text-sm font-medium"
                      >Closed Issue</span
                    >
                  </div>
                  <div
                    class="flex items-center space-x-2"
                    v-if="ticketData.status !== 'Closed'"
                  >
                    <span
                      class="h-5 w-5 text-green-500 flex items-center justify-center"
                    >
                      <i class="fa fa-lock-open"></i>
                    </span>
                    <span class="text-green-700 text-sm font-medium"
                      >Open Issue</span
                    >
                  </div>
                  <div class="flex items-center space-x-2">
                    <span
                      class="h-5 w-5 text-gray-500 flex items-center justify-center"
                    >
                      <i class="fad fa-envelope"></i>
                    </span>
                    <span class="text-gray-900 text-sm font-medium"
                      >{{ ticketData.replies.length }} comments</span
                    >
                  </div>
                  <div class="flex items-center space-x-2">
                    <span
                      class="h-5 w-5 text-gray-500 flex items-center justify-center"
                    >
                      <i class="fad fa-calendar"></i>
                    </span>
                    <span class="text-gray-900 text-sm font-medium"
                      >Created on
                      <time datetime="2020-12-02">{{
                        ticketData.created_at
                          | displayLocalDateTime("MMMM D, YYYY")
                      }}</time></span
                    >
                  </div>
                </div>
                <div class="mt-6 border-t border-gray-200 "></div>
              </aside>
              <div class="py-3 xl:pt-6 xl:pb-0">
                <h2 class="sr-only">Description</h2>
                <div class="prose max-w-none">
                  <p>
                    {{ ticketData.message }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <section
            aria-labelledby="activity-title"
            class="mt-8 xl:mt-10 bg-white rounded p-4"
          >
            <div>
              <div class="divide-y divide-gray-200">
                <div class="pb-4">
                  <h2
                    id="activity-title"
                    class="text-lg font-medium text-gray-900"
                  >
                    Activity
                  </h2>
                </div>
                <div class="pt-6">
                  <!-- Activity feed-->
                  <div class="flow-root">
                    <ul class="-mb-8">
                      <li
                        v-for="(reply, index) in ticketData.replies"
                        v-bind:key="reply.id"
                      >
                        <div class="relative pb-8">
                          <span
                            class="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                            aria-hidden="true"
                            v-if="index !== ticketData.replies.length - 1"
                          ></span>
                          <div class="relative flex items-start space-x-3">
                            <div class="relative">
                              <AccountIcon
                                :initials="reply.user.name | initials(' ')"
                              />

                              <span
                                class="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px"
                              >
                                <!-- Heroicon name: solid/chat-alt -->
                                <svg
                                  class="h-5 w-5 text-gray-400"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                                    clip-rule="evenodd"
                                  />
                                </svg>
                              </span>
                            </div>
                            <div class="min-w-0 flex-1">
                              <div>
                                <div class="text-sm">
                                  <div
                                    class="flex flex-row items-center font-medium text-gray-900"
                                  >
                                    {{ reply.user.name }}
                                  </div>
                                </div>
                                <span
                                  class="mt-0.5 text-sm text-gray-500"
                                  :title="
                                    reply.created_at | displayLocalDateTime
                                  "
                                  v-tippy
                                >
                                  Commented {{ reply.created_at | timeAgo }}
                                </span>
                              </div>
                              <div class="mt-2 text-sm text-gray-700">
                                <p
                                  v-html="reply.message"
                                  v-linkified:options="{
                                    className: 'text-blue-700'
                                  }"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="mt-6">
                    <div
                      class="flex space-x-3"
                      v-if="ticketData.status !== 'Closed'"
                    >
                      <div class="flex-shrink-0">
                        <div class="relative">
                          <AccountIcon :initials="userInitials" />

                          <span
                            class="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px"
                          >
                            <svg
                              class="h-5 w-5 text-gray-400"
                              x-description="Heroicon name: solid/chat-alt"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                          </span>
                        </div>
                      </div>
                      <div class="min-w-0 flex-1">
                        <div>
                          <label for="comment" class="sr-only">Comment</label>
                          <textarea
                            id="comment"
                            name="comment"
                            rows="3"
                            class="shadow-sm block w-full focus:ring-gray-900 focus:border-gray-900 sm:text-sm border-gray-300 rounded-md"
                            placeholder="Leave a comment"
                            v-model="newReply"
                          ></textarea>
                        </div>
                        <div
                          class="mt-6 flex items-center justify-end space-x-4"
                        >
                          <button
                            type="button"
                            class="inline-flex justify-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                            v-on:click="closeTicket"
                          >
                            <svg
                              class="-ml-1 mr-2 h-5 w-5 text-green-500"
                              x-description="Heroicon name: solid/check-circle"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              aria-hidden="true"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            <span>Close issue</span>
                          </button>
                          <button
                            type="submit"
                            class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gray-900 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                            v-on:click="addReply"
                          >
                            Comment
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <aside class="hidden xl:block xl:pl-4 ">
          <h2 class="sr-only">Details</h2>
          <div class="bg-white p-4 space-y-5 rounded">
            <div
              class="flex items-center space-x-2"
              v-if="ticketData.status == 'Closed'"
            >
              <span
                class="h-5 w-5 text-gray-500 flex items-center justify-center"
              >
                <i class="fa fa-lock"></i>
              </span>
              <span class="text-gray-700 text-sm font-medium"
                >Closed Issue</span
              >
            </div>
            <div
              class="flex items-center space-x-2"
              v-if="ticketData.status !== 'Closed'"
            >
              <span
                class="h-5 w-5 text-green-500 flex items-center justify-center"
              >
                <i class="fa fa-lock-open"></i>
              </span>
              <span class="text-green-700 text-sm font-medium">Open Issue</span>
            </div>
            <div class="flex items-center space-x-2">
              <span
                class="h-5 w-5 text-gray-500 flex items-center justify-center"
              >
                <i class="fad fa-envelope"></i>
              </span>
              <span class="text-gray-900 text-sm font-medium"
                >{{ ticketData.replies.length }} comments</span
              >
            </div>
            <div class="flex items-center space-x-2">
              <span
                class="h-5 w-5 text-gray-500 flex items-center justify-center"
              >
                <i class="fad fa-calendar"></i>
              </span>
              <span class="text-gray-900 text-sm font-medium"
                >Created on
                <time datetime="2020-12-02">{{
                  ticketData.created_at | displayLocalDateTime("MMMM D, YYYY")
                }}</time></span
              >
            </div>
          </div>
        </aside>
      </div>
    </div>
  </main>
</template>

<script>
import * as Config from "../../../config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import AccountIcon from "@/components/AccountIcon";

export default {
  name: "Support",
  data() {
    return {
      ticketData: null,
      ticket_id: null,
      newReply: null
    };
  },
  components: {
    AccountIcon
  },
  computed: {
    ...mapGetters(["userInfo", "userInitials"])
  },
  mounted() {
    this.ticket_id = this.$route.params.id;
    this.getTicket();
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    async getTicket() {
      const response = await this.$http.get(
        Config.apiPath + "/api/v2/support/tickets/" + this.ticket_id
      );
      this.ticketData = response.data;
    },
    async addReply() {
      try {
        await this.$http.post(
          Config.apiPath + "/api/v2/support/tickets/" + this.ticket_id,
          { reply: this.newReply }
        );
        this.newReply = null;
        await this.getTicket();
      } catch (e) {
        console.log(e);
        alert("There has been an issue adding a reply. Please try again.");
      }
    },
    async closeTicket() {
      try {
        await this.$http.post(
          Config.apiPath +
            "/api/v2/support/tickets/" +
            this.ticket_id +
            "/close",
          null
        );
        await this.getTicket();
      } catch (e) {
        console.log(e);
        alert("There has been an issue closing this ticket. Please try again.");
      }
    }
  }
};
</script>
